module.exports = __webpack_public_path__ + "img/4-2.221f2aae.png";